/*
 * File: c:\Users\j.mazat\Desktop\mobifleet_front\src\Theme\Component\ButtonCustom.tsx
 * Project: c:\Users\j.mazat\Desktop\mobifleet_front
 * Created Date: Tuesday June 18th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday June 18th 2024 5:34:58 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

// import { StyledComponentType } from "Types/ThemeTypes.type";
import styled from "styled-components";

const ButtonCustom = styled.button.attrs((props: any) => {
    return {
        ...props,
        className: `btn btn-primary`,
    }
}
)`
border: 0;
color: white;
background-color: var(--root-colors-first);
&:disabled {
    color: var(--root-colors-first);
    border: 1px solid var(--root-colors-first);
    background-color: rgba(0, 0, 0, 0);
}
`;

export default ButtonCustom;
